// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__UQuXS","image":"Header_image__kBl1t","name":"Header_name__hdxoQ","info":"Header_info__21vrj","infoRow":"Header_infoRow__T-7Cu"};